import { APIModel } from 'app/state/api';
import { ApiCallModel } from 'app/state/api/interfaces';

const removeOrgUsers: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_AUTH_API}/remove-org-users`),
};

export default removeOrgUsers;
